import React from "react";
var __jsx = React.createElement;
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { CheckboxContainer, CheckboxesContainer, DeleteContentButton, Img, Label, SelectedContentContainer } from './ContentPreview.style';

var ContentPreview = function ContentPreview(_ref) {
  var isNoFollow = _ref.isNoFollow,
      isTargetBlank = _ref.isTargetBlank,
      linkData = _ref.linkData,
      resetSelectedLink = _ref.resetSelectedLink,
      toggleNofollow = _ref.toggleNofollow,
      toggleTargetBlank = _ref.toggleTargetBlank,
      hovered = _ref.hovered;
  return __jsx(SelectedContentContainer, null, hovered && __jsx(DeleteContentButton, {
    onClick: resetSelectedLink,
    "data-testid": "delete-content-button"
  }), __jsx("p", null, linkData.previewUrl && __jsx(Img, {
    src: linkData.previewUrl,
    alt: linkData.label
  }), __jsx(Label, null, linkData.label)), __jsx(CheckboxesContainer, null, __jsx(CheckboxContainer, null, __jsx(FormControlLabel, {
    control: __jsx(Checkbox, {
      color: "default",
      disableRipple: true,
      checked: isNoFollow,
      onClick: toggleNofollow
    }),
    label: __jsx(FormattedMessage, {
      id: "link.nofollow"
    })
  })), __jsx(CheckboxContainer, null, __jsx(FormControlLabel, {
    control: __jsx(Checkbox, {
      color: "default",
      disableRipple: true,
      checked: isTargetBlank,
      onClick: toggleTargetBlank
    }),
    label: __jsx(FormattedMessage, {
      id: "link.target-blank"
    })
  }))));
};

export default ContentPreview;